import React, { useEffect, useState } from "react";
import { Col, Row } from "react-bootstrap";
import imgOtherMySpace from "../../assets/image-not-available.png";
import { ReactComponent as ActiveStep } from "../../assets/svg/active-icon.svg";
import { ClickAwayListener, Tooltip, withStyles } from "@material-ui/core";

import { getFile } from "../../services/FileManager";
import {
  ContentTooltip,
  DateDescription,
  MySpaceDescription,
  MySpaceTitle,
  useStyles,
} from "./ListCardMyGames.styled";
import InfoIcon from "@material-ui/icons/Info";
import { theme as themeConfig } from "../../themes/themes";

const HtmlTooltip = withStyles((theme) => ({
  tooltip: {
    pointerEvents: "auto",
    backgroundColor: "white",
    margin: "9 0",
    color: themeConfig.neutral.gray[2500],
    border: "1px solid #dadde9",
    boxShadow: "4px 4px #92929236",
  },
}))(Tooltip);

const ListCardMyGames = ({ myGame, goToDetail }) => {
  const classes = useStyles();
  const [previewImage, setPreviewImage] = useState(imgOtherMySpace);
  const [openInfo, setOpenInfo] = useState(null);

  const formatDate = (date) => {
    let formatted = new Date(date).toGMTString();
    let ampm = "";
    ampm = parseInt(formatted.substring(17, 19));
    ampm = ampm > 12 ? " PM" : " AM";
    formatted =
      formatted.substring(0, 16) +
      " | " +
      formatted.substring(17, 22) +
      ampm +
      " GMT";
    return formatted;
  };

  useEffect(() => {
    if (myGame.coverImage) {
      getFile(myGame.coverImage).then((response) => {
        if (response && response.type !== "archivo-noexistente/json") {
          setPreviewImage(URL.createObjectURL(response));
        }
      });
    } else {
      setPreviewImage(imgOtherMySpace);
    }
  }, [myGame.coverImage]);

  return (
    <Row className={classes.containerSpace}>
      <Col md={4} >
        <img src={previewImage} className={classes.imgOtherEvent} alt="" />
      </Col>
      <Col md={8} className={classes.cardRightContent}>
        <MySpaceTitle onClick={() => goToDetail(myGame)}>
          {myGame.name}
        </MySpaceTitle>
        <MySpaceDescription>
          <span>
            Created By {myGame.createdByName}
          </span>{" "}
          <span style={{ color: themeConfig.text.primary }}>
            <HtmlTooltip
              arrow
              placement="right"
              open={openInfo}
              title={
                <>
                  <ClickAwayListener onClickAway={(e) => setOpenInfo(null)}>
                    <ContentTooltip>
                      <div>
                        <span style={{ fontWeight: "600" }}>Topic:</span>{" "}
                        <span style={{ fontWeight: "400" }}>
                          {openInfo && openInfo.topic}
                        </span>
                      </div>
                      <div>
                        <span style={{ fontWeight: "600" }}>Description:</span>{" "}
                        <span style={{ fontWeight: "400" }}>
                          {openInfo && openInfo.description}
                        </span>
                      </div>
                    </ContentTooltip>
                  </ClickAwayListener>
                </>
              }
            >
              <InfoIcon
                onClick={() => setOpenInfo(myGame)}
                style={{ fontSize: "20px", cursor: "pointer" }}
              />
            </HtmlTooltip>
          </span>
        </MySpaceDescription>
        <DateDescription>
          <ActiveStep style={{ marginBottom: "0.1em" }} /> {"Active until "}
          {formatDate(myGame.endDate)}
        </DateDescription>
      </Col>
    </Row>
  );
};
export default ListCardMyGames;
